import React from "react";
import "../App.css";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const menuItems = [
    { path: "/setting", icon: "bi bi-gear-fill", label: "Settings" },
    { path: "/liked", icon: "bi bi-person-fill",  label: "Liked" },
    { path: "/home", icon: "bi bi-house-fill", label: "Home" },
    { path: "/profile", customIcon: "💖", label: "Profiles" },
    { path: "/notification", icon: "bi bi-chat-dots-fill", label: "Chat & Likes" },
  ];

  return (
    <div className="footer">
      <div className="footer-inner d-flex justify-content-around align-items-center">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          const isLiked = item.label === "Liked";

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`footer-item text-decoration-none ${
                isActive ? "active-footer" : ""
              }`}
            >
              <div
                className={`icon-circle ${
                  isLiked ? "like-heart" : ""
                } ${isActive ? "active-icon" : ""}`}
              >
                {item.customIcon ? (
                  <span className="fs-5 heart-beat">{item.customIcon}</span>
                ) : (
                  <i className={`${item.icon} fs-5`}></i>
                )}
              </div>
              <small>{item.label}</small>
            </Link>
          );
        })}
      </div>

      <style>{`
      

        .footer-inner {
          width: 100%;
          max-width: 500px;
          margin: 0 auto;
        }

        .footer-item {
          color: #555;
          text-align: center;
          transition: all 0.3s ease;
        }

        .footer-item small {
          display: block;
          font-size: 12px;
        }

        .footer-item.active-footer {
          color: #dc3545;
        }

        .icon-circle {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;
          transition: all 0.3s ease;
        }

        .icon-circle.active-icon {
          background-color: #ffe6e6;
          color: #dc3545;
          box-shadow: 0 0 8px rgba(220, 53, 69, 0.3);
        }

        /* 💖 Continuous Beating Heart */
        .heart-beat {
          display: inline-block;
          color: #dc3545;
          animation: beat 1.2s infinite ease-in-out;
          transform-origin: center;
        }

        @keyframes beat {
          0% { transform: scale(1); opacity: 0.9; }
          25% { transform: scale(1.2); opacity: 1; }
          50% { transform: scale(1); opacity: 0.95; }
          75% { transform: scale(1.15); opacity: 1; }
          100% { transform: scale(1); opacity: 0.9; }
        }

        .like-heart:hover .heart-beat {
          animation: beat 0.6s infinite ease-in-out;
          transform: scale(1.3);
        }
      `}</style>
   
    </div>
  );
};

export default Footer;
